import { fetchWithCredentials } from './client';

export interface ProfileResponse {
  success: boolean;
  data: {
    identityId: string;
    tenantId: string;
    firstName: string;
    lastName: string;
    username: string;
    cxoneAgentId: string;
    status: string;
  };
}

export const profileApi = {
  async getProfile(): Promise<ProfileResponse> {
    return fetchWithCredentials<ProfileResponse>('/api/v1/profile');
  },

  async updateProfile(data: {
    firstName?: string;
    lastName?: string;
  }): Promise<{ success: boolean; data: unknown }> {
    return fetchWithCredentials('/api/v1/profile', {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },
};
